import styled from "styled-components";
//Hooks
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//Icons
import { CaretDown, X, MagnifyingGlass } from "@phosphor-icons/react";
import { useState } from "react";

interface IFilter {
  name: string;
  data: string[] | number[];
  setPopMenuList: (value: string | number) => void;
  filterActive?: boolean
}

export default function FilterTable({
  name,
  data,
  setPopMenuList,
  filterActive = false
}: IFilter) {
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const [inputValue, setInputValue] = useState('');

  const handleSelect = (value: string | number) => {
    setPopMenuList(value);
    toggleModalVisibility("menu");
  };


  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(event.target.value);
    if (value === '') {
      setPopMenuList('')
    }
  };

  const handleSearch = (event?: React.FormEvent) => {
    event?.preventDefault();
    setPopMenuList(inputValue.trim());
  };

  return (
    <Container>
      <ButtonHead
        onClick={() => toggleModalVisibility("menu")}
        className={filterActive ? "active" : ""}
      >
        {name}
        <CaretDown size={16} weight="fill" />
      </ButtonHead>

      {isOpenModal("menu") && (
        <Content ref={(ref) => assignRef("menu", ref)}>
          <ContentInputSearch>
            {/* Pesquisar por input */}
            <Input
              type="text"
              placeholder={`Burcar ${name}`}
              onChange={handleInputChange}
            />
            <ContentButton>
              <ButtonClose onClick={() => setPopMenuList('')}>
                <X size={18} weight="fill" />
              </ButtonClose>

              <ButtonSearch onClick={handleSearch}>
                <MagnifyingGlass size={18} />
              </ButtonSearch>
            </ContentButton>
          </ContentInputSearch>

          {/* Pesquisar por button */}
          {data.map((item, index) => (
            <ButtonMenu key={index} >
              <p
                onClick={() => handleSelect(item)}
              >
                {item}
              </p>

              <ButtonClose onClick={() => setPopMenuList('')}>
                <X size={18} weight="fill" />
              </ButtonClose>
            </ButtonMenu>
          ))}
        </Content>
      )}
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  `;

const ButtonHead = styled.button`
  background-color: transparent;
  font-size: 16px;
  font-weight: 700;

  &.active {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Content = styled.div`
  position: absolute;
  z-index: 2;
  margin-top: 5px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
  border-radius: 4px;
  padding: 5px 3px;
  width: 100%;

  height: 250px;
    
  overflow: scroll;
  &::-webkit-scrollbar { 
      display: none;
  }
`;

const ButtonMenu = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
  }
  p{
    width: 70%;
  }
`;

const ContentInputSearch = styled.div`
  display: flex;
  align-items:center;
  width: 100%;
  padding: 5px 10px;

  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
  border-radius: 4px;
  font-size: 16px;
`;

const Input = styled.input`
  width: 75%;
  &::placeholder{
    font-size: 14px;
  }
`;

const ContentButton = styled.div`
  width: 25%;
  display: flex;
  gap: 3px;
`;

const ButtonClose = styled.button`
  display: flex;
  justify-content: center;
  background-color: transparent;
  padding: 4px 0px;

  svg:hover{
    background-color: ${(props) => props.theme.colors.gray.gray_100};
  }
  `;

const ButtonSearch = styled.button`
  display: flex;
  justify-content: center;
  background-color: transparent;
  padding: 4px 0px;
  border-radius: 30px;
  
  svg:hover{
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => props.theme.colors.primary};
  }
`;